import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  getAudienceSlug,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import Artifact from "./Artifact";
import CompareModal from "./CompareModal";
import { getAudienceEmoji } from "posts/constants";

function BrandsCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-tough-cookies-brands-betty-crocker.png"
              imageAlt="Betty Crocker logo"
              title="Betty Crocker"
              subtitle="Cooking"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.bettycrocker.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-brands-discover.png"
              imageAlt="Discover logo"
              title="Discover"
              subtitle="Credit Card"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.discover.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-brands-purina.png"
              imageAlt="Purina logo"
              title="Purina"
              subtitle="Pets"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.purina.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-dont-tread-brands-winndixie.png"
              imageAlt="Winn-Dixie logo"
              title="Winn-Dixie"
              subtitle="Grocery"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.winndixie.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-brands-chewy.png"
              imageAlt="Chewy.com logo"
              title="Chewy.com"
              subtitle="Pets"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.chewy.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-brands-espn.png"
              imageAlt="ESPN logo"
              title="ESPN"
              subtitle="Sports"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.espn.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-peoplepower-brands-starbucks.png"
              imageAlt="Starbucks logo"
              title="Starbucks"
              subtitle="Coffee"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.starbucks.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-brands-apple.png"
              imageAlt="Apple Computer logo"
              title="Apple"
              subtitle="Consumer Electronics"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.apple.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profile-peoplepower-brands-nerdwallet.png"
              imageAlt="Nerd Wallet logo"
              title="Nerd Wallet"
              subtitle="Personal Finance"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.nerdwallet.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-brands-nintendo.png"
              imageAlt="Nintendo logo"
              title="Nintendo"
              subtitle="Consumer Electronics"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.nintendo.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-brands-bestbuy.png"
              imageAlt="Best Buy logo"
              title="Best Buy"
              subtitle="Consumer Electronics"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.bestbuy.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-brands-bofa.png"
              imageAlt="Bank of America logo"
              title="Bank of America"
              subtitle="Banking"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.bankofamerica.com/"
              small={small}
            />
          </>
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Brands
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Brands</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default BrandsCard;
